import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { RiSearchLine, RiFilterLine } from "react-icons/ri";
import { statusOptions } from "../../constants/Constants";
import { errorAlert } from "../../components/common/Alert";
import { getParkingLocationsDropDownList } from "../../services/Networkcall";

function GateCodeFilters({ filters, setFilters, }) {

    const [locationOptions, setLocationOptions] = useState([]);

    const fetchParkingLocationsDropDownList = async () => {
        try {
            const res = await  getParkingLocationsDropDownList();
            if (res?.success) {
                const options = res?.data.map((item) => ({ name: item?.locationName, value: item?._id }));
                setLocationOptions(options);
            }
            else {
                errorAlert({message:res?.message})
            }
        } catch (err) {
            errorAlert({message:err?.response?.data?.message || err?.message || 'something went wrong'})
        }
    }

    useEffect(() => { fetchParkingLocationsDropDownList(); }, [])
    
    const handleReset = () => {
        setFilters({ search: '', startDate: null, endDate: null, status: '', locationId: '' })
    }

    return (
        <Row className="mv-filters mt-3">

            {/* SEARCH */}
            <Col xl={4} lg={4} md={12}>
                <label className="small text-muted mb-1">Search</label>
                <div className="mv-search">
                    <RiSearchLine />
                    <input
                        placeholder="Search by driver, truck/plate"
                        type="text"
                        value={filters.search}
                        onChange={(e) => setFilters((pre) => ({ ...pre, search: e.target.value }))} />
                </div>
            </Col>

            <Col xl={2} lg={3} md={4}>
                <div className="mv-field">
                    <label>Status</label>
                    <Form.Select
                        value={filters.status}
                        onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}>
                        <option value="All">All</option>
                        {statusOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Form.Select>
                </div>
            </Col>

            
            <Col xl={2} lg={3} md={4}>
                <div className="mv-field">
                    <label>Location</label>
                    <Form.Select
                        value={filters.locationId}
                        onChange={(e) => setFilters(prev => ({ ...prev, locationId: e.target.value }))}>
                        <option value="All">All</option>
                        {locationOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.name}
                            </option>
                        ))}
                    </Form.Select>
                </div>
            </Col>

            <Col xl={3} lg={3} md={4}>
                <div className="date-picker-wrapper flex-column d-flex">
                    <label className="mb-1 small text-muted">Select Range  </label>

                    <DatePicker
                        placeholderText="dd/mm/yyyy - dd/mm/yyyy"
                        selectsRange
                        startDate={filters?.startDate}
                        endDate={filters?.endDate}
                        onChange={(update) => {
                            setFilters((pre) => ({
                                ...pre,
                                "startDate": update[0],
                                "endDate": update[1],
                            }));
                        }}
                        className="form-control w-100 cursor-pointer"
                        dateFormat="dd/MM/yyyy"
                    />
                </div>
            </Col>



            {/* FILTER BUTTON */}
            <Col xl={1} lg={1} md={12}>
                <Button className='' onClick={handleReset}>
                    Reset
                </Button>
            </Col>

        </Row>
    );
}

export default React.memo(GateCodeFilters);